module.exports = __webpack_public_path__ + "static/img/qualifications_row_12.ae42be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_12.png
// module id = Qe1L
// module chunks = 1